import Nav from "@/components/Nav";
import Cursor from "@/components/Cursor";
import Seo from "@/components/Seo";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative">
      <Seo
        title="KS DevArc · Development & Architecture · Build Smarter Digital Solutions"
        description="KS DevArc helps small businesses modernize operations through websites, applications, automation, and AI-powered technology solutions — built for growth and efficiency."
        url={typeof window !== "undefined" ? window.location.origin + "/" : ""}
      />
      <Cursor />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Process />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
